import { memo } from 'react';
import Icon from '@dtvgo/icon';
import { ProgressBarClassNames, ScrubbingDirection } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function ScrubbingSpeedIcon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? undefined : _ref$speed,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? undefined : _ref$direction;
  return speed && direction ? /*#__PURE__*/jsx(Icon, {
    name: "scrubbing-speed-".concat(speed),
    className: ProgressBarClassNames.element('scrubbing-speed-icon', {
      backward: direction === ScrubbingDirection.BACKWARD
    }, className)
  }) : null;
}
var ScrubbingSpeedIcon$1 = /*#__PURE__*/memo(ScrubbingSpeedIcon);

export { ScrubbingSpeedIcon$1 as default };
//# sourceMappingURL=ScrubbingSpeedIcon.js.map
